import { useMemo } from "react";
import { useMainStore } from "@/stores";
import { USER_ROLES } from "@/shared/utils/constants";
import { useFetchUsersList } from "@/shared/hooks";

// count pending join requests for org admin/super admin
export function useSidebarBadges() {
  const { user, appMode } = useMainStore();

  const enabled =
    user?.role === USER_ROLES.ORG_ADMIN ||
    user?.role === USER_ROLES.SUPER_ADMIN ||
    user?.role === USER_ROLES.SUPER_ADMIN_ALT;

  // This hook is mounted on every screen for admins. A pending-request badge does
  // not need 15 s freshness, and the admin screens that act on those requests keep
  // the fast default.
  const { data: usersList } = useFetchUsersList({
    limit: 100,
    offset: 0,
    enabled,
    refetchInterval: 5 * 60_000,
    refetchOnWindowFocus: false,
    staleTime: 60_000,
  });

  const pendingCount = useMemo(() => {
    const list = usersList ?? [];
    return list.filter((u) => u.trial_approved_at == null && u.plan !== "reject").length;
  }, [usersList]);

  return useMemo(() => {
    const badges = {};
    if (pendingCount > 0) {
      if (user?.role === USER_ROLES.ORG_ADMIN) {
        badges["Pending Requests"] = pendingCount;
      }
      // if (
      //   user?.role === USER_ROLES.SUPER_ADMIN ||
      //   user?.role === USER_ROLES.SUPER_ADMIN_ALT
      // ) {
      //   badges["Organizations"] = pendingCount;
      // }
    }
    return badges;
  }, [user?.role, appMode, pendingCount]);
}
